import { useEffect } from 'react'
import TagManager from 'react-gtm-module/dist/TagManager'
import { installCdnLinkGuard } from './analytics/cdnLinkGuard'

function GTMProvider({ children, gtmId }) {
  useEffect(() => {
    //if (process.env.NODE_ENV !== 'development') {
    const removeCdnLinkGuard = installCdnLinkGuard()
    const tagManagerArgs = { gtmId }
    TagManager.initialize(tagManagerArgs)
    //}
    return removeCdnLinkGuard
  }, [])

  return children
}

export default GTMProvider
